export interface SseParser {
  push(chunk: string): unknown[];
  flush(): unknown[];
}

function parseBlock(block: string): unknown[] {
  const data = block
    .split(/\r?\n/)
    .filter((line) => line.startsWith("data:"))
    .map((line) => line.slice(5).replace(/^ /, ""))
    .join("\n");
  return data.length > 0 ? [JSON.parse(data)] : [];
}

export function createSseParser(): SseParser {
  let buffer = "";
  return {
    push(chunk: string): unknown[] {
      buffer += chunk;
      const blocks = buffer.split(/\r?\n\r?\n/);
      buffer = blocks.pop() ?? "";
      return blocks.flatMap(parseBlock);
    },
    flush(): unknown[] {
      const rest = buffer;
      buffer = "";
      return parseBlock(rest);
    }
  };
}
